import { SVGProps } from 'react'

const MeltIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12.952 11.272c1.505-2.94.58-5.638-1.471-7.917-.07.592-.469 1.934-1.357 2.06C7.902 5.729 7.58 2.475 9.13 1 9.13 1 7.277.48 6 2.75c-.94 1.669-.763 3.325-2.148 3.175-.868-.095-1.498-1.597.127-3.501 0 0-1.73.617-3.026 3.246-1.437 2.916-.175 5.702.79 6.767 1.182 1.302 1.997 1.731 2.91 2.101.62.25 1.697.566 3.345.325 2.107-.308 3.92-1.57 4.954-3.591Zm-5.334 2.81c-2.6.278-4.824-1.85-3.615-4.658.54-1.254 1.831-1.808 1.831-1.808-.856 1.02-.68 1.81-.232 1.84.744.053.695-.783 1.213-1.823.62-1.242 1.27-1.268 1.27-1.268-.337.988.137 1.877 1.027 2.64 2.338 1.922.667 4.844-1.494 5.077Z"
    />
  </svg>
)
export default MeltIcon
